import { GET_ALL_USERS, GET_DEPARTMENTS, GET_AREAS, } from "./types";
const INITIAL_STATE = {
    users: false,
    requesting: false,
    departments: false,
    areas: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_ALL_USERS.REQUEST: {
            return { ...state, requesting: true, users: false };
        }
        case GET_ALL_USERS.FAIL: {
            return { ...state, requesting: false, users: false };
        }
        case GET_ALL_USERS.SUCCESS: {
            return { ...state, requesting: false, users: action.payload };
        }
        case GET_DEPARTMENTS.REQUEST: {
            return { ...state, requesting: true, departments: false };
        }
        case GET_DEPARTMENTS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                departments: action.payload
            };
        }
        case GET_DEPARTMENTS.FAIL: {
            return { ...state, requesting: false, departments: false };
        }
        case GET_AREAS.REQUEST: {
            return { ...state, requesting: true, areas: false };
        }
        case GET_AREAS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                areas: action.payload
            };
        }
        case GET_AREAS.FAIL: {
            return { ...state, requesting: false, areas: false };
        }
        default: {
            return { ...state };
        }
    }
};
